import create, { UseStore } from "zustand";
import { StoreApi } from "zustand/vanilla";
import { CultureModel, listApplicationCultures } from "client/Api/Localization/userCulture";
import { AutoFetchStoreData, createAutoFetchStore } from "client/zustand/createAutoFetchStore";
import { EMPTY_ARRAY } from "client/Misc/utils";

export const applicationCultureStore: StoreApi<AutoFetchStoreData<readonly CultureModel[]>> = createAutoFetchStore<readonly CultureModel[]>(
	EMPTY_ARRAY,
	listApplicationCultures
);

export const useApplicationCultureStore: UseStore<AutoFetchStoreData<readonly CultureModel[]>> = create(applicationCultureStore);